import { FC, useRef } from 'react';

import HotTable, { HotColumn } from '@handsontable/react';
import { sortBy, toUpper } from 'lodash';
import { IList } from 'core/API/listApi';
import { MVATHeader, translateHeaders } from './helpers/HeadersList';
import RetailerRenderer from './helpers/CustomDropboxRenderer';
import Grid from '../Grid';
import { requireTitle } from './helpers/utils';
import { CustomIntervalRenderer } from './helpers/customRenderers';

export const MVAT: FC<{
    list: IList;
    toolId: number;
    segments: any[];
}> = ({ list, toolId, segments }) => {
    const hotRef = useRef<HotTable | null>(null);
    const translatedHeaders = translateHeaders(MVATHeader);
    const sortedSegments = sortBy(segments, [(o) => toUpper(o.name)]);

    return (
        <Grid toolId={toolId} paramHotRef={hotRef} headers={MVATHeader} list={list}>
            <HotColumn title={requireTitle(translatedHeaders[0])} readOnly={true}>
                <RetailerRenderer customList={sortedSegments} hotInstance={hotRef} hot-renderer />
            </HotColumn>
            <HotColumn allowEmpty={false} type="numeric" title={requireTitle(translatedHeaders[1])}>
                <CustomIntervalRenderer allowEmpty={false} min={0} max={100} hot-renderer />
            </HotColumn>
        </Grid>
    );
};
